import React from 'react';

import SearchField from './SearchField';
import CityWeather from './CityWeather';

function Home() {
  return (
    <>
      <SearchField />
      <CityWeather />
    </>
  );
}

export default Home;
